/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./AIMobileChatsMessages.css";
import {
  Channel,
  Window,
  MessageList,
  MessageInput,
  Thread,
} from "stream-chat-react";
import { Channel as ChannelType } from "stream-chat/dist/types/channel";
import { DefaultGenerics } from "stream-chat/dist/types/types";
import "stream-chat-react/dist/css/v2/index.css";

type props = {
  channel: ChannelType<DefaultGenerics>;
};

export const AIMobileChatsMessages: React.FC<props> = ({ channel }) => {
  return (
    <div className="channel-wrapper">
      <div style={{ height: 30 }} />
      <Channel channel={channel}>
        <Window>
          <MessageList />
          <MessageInput />
        </Window>
        <Thread />
      </Channel>
    </div>
  );
};
